<template>
    <div>
        <div class="loader" :style="loaderStyles" />
    </div>
</template>

<script>
// styles won't work by some reason
export default {
  name: 'Loader',
  props: {
    width: { type: Number, default: 80 },
    height: { type: Number, default: 80 }
  },
  data () {
    return {
      loaderStyles: {
        width: this.width + 'px ',
        height: this.height + 'px '
      }
    }
  }
}
</script>

<style scoped>
    .loader {
        border: 12px solid #f3f3f3; /* Light grey */
        border-top: 12px solid #3498db; /* Blue */
        border-radius: 50%;
        /*width: 80px;*/
        /*height: 80px;*/
        animation: spin 2s linear infinite;
        margin: auto;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>



// WEBPACK FOOTER //
// src/globals/loader.vue